import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  flightDetailsModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flightDetailsClose: {
    color: Theme.palette.primary.light,
    height: '30px',
    position: 'absolute',
    right: '30px',
    top: '30px',
    width: '30px',
    [Theme.breakpoints.down('sm')]: {
      right: '20px',
    },
  },
  flightDetailsBody: {
    outline: 'none',
    fontFamily: Theme.typography.base.regular,
    position: 'absolute',
    width: '860px',
    backgroundColor: Theme.palette.white,
    maxHeight: '700px',
    overflow: 'auto',
    boxShadow: `0 2px 4px 0 ${Theme.palette.shadowOpacity}`,
    [Theme.breakpoints.down('lg')]: {
      width: '780px',
    },
    [Theme.breakpoints.down('md')]: {
      width: '90%',
      maxHeight: '95%',
    },
  },
  flightDetailsTitle: {
    color: Theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[6],
    lineHeight: '150%',
    margin: '40px 40px 0 40px',
    [Theme.breakpoints.down('sm')]: {
      margin: '40px 30px 16px 20px',
      fontSize: Theme.typography.size[3],
    },
  },
  multiAirlineLogo: {
    alignSelf: 'center',
  },
  flightDetailsDate: {
    marginLeft: '10px',
  },
  expandedItineraryModal: {
    margin: '20px 60px 20px 60px',
    '&:last-child': {
      marginBottom: '40px',
    },
    [Theme.breakpoints.down('lg')]: {
      marginRight: '40px',
    },
    [Theme.breakpoints.down('md')]: {
      marginRight: '30px',
    },
    [Theme.breakpoints.down('sm')]: {
      margin: '16px 20px 16px 30px',
      '&:last-child': {
        marginBottom: '30px',
      },
    },
  },
}));

export default useStyles;
